import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';



@Injectable()
export class RouteUtilService implements OnDestroy {
  get previousUrl(): string {
    return this.prevUrl;
  }

  get activeUrl(): string {
    return this.currUrl;
  }
  
  setNav$: Subject<any> = new Subject<any>();
  private prevUrl:any = null;
  private currUrl:any = null;
  private readonly ngUnsubscribe = new Subject<void>();

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd), takeUntil(this.ngUnsubscribe))
      .subscribe((e: any) => {
        this.prevUrl = this.currUrl;
        this.currUrl = e.url;
      });
  }

  navigate(url: any): void {
    this.router.navigateByUrl(url, { replaceUrl: true });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
